/* global angular, moment */
/**
 * Created by lari on 27/04/2017.
 */
(function () {
  'use strict';
  angular.module('vcexam')
    .component('currentexams', {
      restrict: 'E',
      bindings: {
        // examinations: '='
        consultid: '<'
      },
      templateUrl: 'vcexam/currentexams-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Rlog', 'Exam', 'ExamHelper', 'vertxEventBusService', '$window', 'PrintHelper', '$timeout',
        function ($log, Rlog, Exam, ExamHelper, vertxEventBusService, $window, PrintHelper, $timeout) {
          let vm = this;
          vm.deleteExam = deleteExam;
          vm.finishExam = ExamHelper.finishExam;
          vm.showeditor = showeditor;
          vm.showview = showview;
          vm.setprint = setprint;
          vm.examPreviewUrl = PrintHelper.examPreviewUrl;

          vm.$onInit = function () {
            vm.status = {};
            vm.status.isOpen = [];
            vm.status.isOpen[0] = true;
            $log.debug('vm.status: ', vm.status);
            if (angular.isDefined(vm.consultid)) {
              let query = {consultid: vm.consultid};
              Exam.$search(query).$then(function (exams) {
                vm.examinations = exams;
              });
            }
          };

          // vm.consultid might be late propagating, get exams on first change
          vm.$onChanges = function (changes) {
            if (!changes.isFirstChange) {
              // if (angular.isDefined(changes.consultid.currentValue)) {
              vm.consultid = changes.consultid.currentValue;
              if (angular.isDefined(vm.consultid)) {
                Exam.$search({consultid: vm.consultid}).$then(function (exams) {
                  vm.examinations = exams;
                  // TODO: code only needed during development, remove before final release
                  for (let i = 0; i < vm.examinations.length; i++) {
                    if (angular.isUndefined(vm.examinations[i].print)) {
                      vm.examinations[i].print = true;
                      vm.examinations[i].$save();
                    }
                  }
                  // $log.debug('******* current exams : ', exams);
                }, function (err) {
                  $log.error('exam lookup failed for consultid id: ', vm.consultid);
                  Rlog.error('exam', 'currentexams', 'exam lookup failed', {consultid: vm.consultid});
                });
              }
            }
          };

          function setprint(exam, val) {
            exam.print = val;
            $log.debug('Changing exam print status to: ', val, exam);

            exam.$save();
          }

          function showeditor(open, edit) {
            return ((open === true && (angular.isUndefined(edit) || edit === true)) ||
              (open === false && edit === true));
          }


          function showview(open, edit) {
            return ((open === true && edit === false) ||
              (open === false && (edit === false || angular.isUndefined(edit))));
          }


          function deleteExam(exam) {
            exam.active = false;
            if (exam.$hasPendingActions) {
              $log.warn('[EXAM][CurrentExams] exam delete save had pending actions, cancelling now.');
              exam.$cancel();
              $timeout(function () {
                $log.warn('[EXAM][CurrentExams]  waited 1.5 seconds because of exam having had pending actions, saving now.');
                savesave(exam);
              }, 1500);
            } else {
              savesave(exam);
            }
          }

          function savesave(exam) {
            exam.$save().$then(function () {
              $log.debug('exam helper factory finishexam save successful');

            }, function () {
              $log.error('exam helper factory finishexam save failed');

              Rlog.debug('exam', 'examhelperfactory', 'exam finish (save) failed', {examid: exam._id});
            });
          }


          const examCreateHandle = function (message) {
            // $log.debug('debug: Exam create received: ', message);
            let messages = message.split(':');
            if (angular.isDefined(vm.examinations)) {
              vm.examinations.$refresh().$then(function () {
                if (angular.isDefined(vm.status) && angular.isDefined(vm.status.isOpen)) {
                  vm.status.isOpen[0] = true;
                }
                $log.debug('debug: currentexams refreshed');
              }, function (error) {
                $log.debug('debug: currentexams could not refresh exams: ', error);
              });
            }
          };

          $log.debug('[Vert.x subscribe] examinations.create');
          vertxEventBusService.on('examinations.create', examCreateHandle);


          vm.$onDestroy = function () {
            $log.debug('[Vert.x unsubscribe] examinations.create');

            vertxEventBusService.unregisterHandler('examinations.create', {}, examCreateHandle);
          };

        }] // controller
    }); // component

// klammerfriedhof
}());